// extracted by mini-css-extract-plugin
export default {"container":"styles_container__LsKwf","title":"styles_title__uiWef","qrCode":"styles_qrCode__i52eg"};